import React, { useState } from 'react';
import Loading from '../components/Loading';
import ZodiacSelector from '../components/ZodiacSelector';
import { getPlanetaryTransits, isGeminiReady } from '../services/geminiService';
import { useLanguage } from '../context/LanguageContext';

export default function Transits() {
  const [selectedSign, setSelectedSign] = useState('');
  const [reading, setReading] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { language, t } = useLanguage();

  const handleGetTransits = async () => {
    if (!selectedSign) return;
    if (!isGeminiReady()) {
      setError(t('apiKeyError'));
      return;
    }
    setLoading(true);
    setError('');
    setReading('');
    try {
      const result = await getPlanetaryTransits(selectedSign, language);
      setReading(result);
    } catch (err) {
      setError(err.message || 'Failed to get planetary transits.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <div className="container">
        <div className="page-header">
          <h2>{t('transitsTitle')}</h2>
          <p>{t('transitsDesc')}</p>
        </div>

        <ZodiacSelector selectedSign={selectedSign} onSelect={setSelectedSign} />

        {selectedSign && (
          <div style={{ textAlign: 'center', marginTop: '2rem' }}>
            <button className="btn btn-primary" onClick={handleGetTransits} disabled={loading}>
              {loading ? t('scanningCosmos') : t('getTransits', { sign: selectedSign })}
            </button>
          </div>
        )}

        {loading && <Loading message={t('loadingTransits')} />}
        {error && <div className="error-message">{error}</div>}

        {reading && (
          <div className="result-container">
            <div className="result-card">
              <h3>{t('transitsResult', { sign: selectedSign })}</h3>
              <div className="content">{reading}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
